import RootWrapper from './src/components/ui/root-wrapper';
export const wrapRootElement = RootWrapper;
export const wrapPageElement = RootWrapper;
